import { DataAttributeDefinitions } from 'scrivito'

import { pisaRegionDataClass } from './Pisa/pisaRegionDataClass'

const attributes: DataAttributeDefinitions = {}

export const Region = pisaRegionDataClass(attributes)
